// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"go-z","slideIn":"ho-z"};